import { IconUserPlus as TablerIconUserPlus } from '@tabler/icons-react';

import { createOutlineIcon } from '@/components/icon/createOutlineIcon';

export const IconUserPlus = /*#__PURE__*/ createOutlineIcon(TablerIconUserPlus, 'IconUserPlus');
